module.exports = __webpack_public_path__ + "img/topBg.eb4051f1.png";